// src/utils/GameAssets.js

// --- PATH CONFIGURATION ---
const A = "/assets";            // Autarky Assets (Main Game)
const V = "/assets/veridian";   // Veridian Assets (Mini Game)

export const ASSETS = {
  // --- AUDIO (Updated to use Veridian Path) ---
  AUDIO: {
    Ambience: `${V}/audio/ambience_drone.mp3`, 
    Unlock: `${V}/audio/sector_unlock.mp3`,
    Type: `${V}/audio/typing_blip.mp3`,
    Error: `${V}/audio/error_buzz.mp3`,
    Success: `${V}/audio/success_chime.mp3`,
  },

  // --- THEMES ---
  THEMES: {
    Fracture: `${A}/themes/fracture_theme.mp3`,
    Ascent: `${A}/themes/ascent-theme.mp3`,
    Recalibration: `${A}/themes/recalibration%20_theme.mp3`,
  },

  // --- NARRATIVE ---
  NARRATIVE: {
    Text1: `${A}/narrative_scripts/Text%201.mp4`,
    Text2: `${A}/narrative_scripts/Text%202.mp4`,
    Text3: `${A}/narrative_scripts/Text%203.mp4`,
    Text4: `${A}/narrative_scripts/Text%204.mp4`,
    InvestigatorIntro: `${A}/narrative_scripts/investigator_intro.mp4`,
    CommissionerIntro: `${A}/narrative_scripts/comissioner_intro.mp4`,
    PoliticianIntro: `${A}/narrative_scripts/politician_intro.mp4`,     
    FalseCeiling: `${A}/narrative_scripts/registrar_intro.mp4`, 
    TheNewGame: `${A}/narrative_scripts/bidding_intro.mp4`,     
    Climax: `${A}/narrative_scripts/electoratia_intro.mp4`,      
  },

  // --- CHAPTERS ---
  CHAPTERS: {
    Age1_Intro: `${A}/chapter_markers/age_1_chapter_marker.mp4`,
    Age2_Intro: `${A}/chapter_markers/age_2_ascent_marker.mp4`,
    Age3_Intro: `${A}/chapter_markers/age_3_recalibration_marker.mp4`,
  },
  
  // --- TRANSITIONS ---
  TRANSITIONS: {
    ToAscent: `${A}/transitions/transition_1_to_2.mp4`,
    ToRecalibration: `${A}/transitions/trnasition%202_to_3.mp4`, 
  },

  // --- NPCS ---
  NPCS: {
    Investigator: `${A}/npcs/investigator_idle.mp4`,
    Commissioner: `${A}/npcs/commissioner_idle.mp4`,
    Politician: `${A}/npcs/politician_idle.mp4`,
    Officer: `${A}/npcs/offcer_idle.mp4`, 
    HR: `${A}/npcs/hr_idle.mp4`,
    Manager: `${A}/npcs/manager_idle.mp4`,
    Registrar: `${A}/npcs/registrar_idle.mp4`,
    HeadOfBidding: `${A}/npcs/bidding_idle.mp4`,
    Electoratia: `${A}/npcs/electoratia_idle.mp4`,
    Consultant: `${A}/npcs/consultant_idle.mp4`
  },

  // --- VERIDIAN VISUALS ---
  VERIDIAN_VISUALS: {
    Infrastructure: `${V}/visuals/reactor_core_offline.jpg`,
    Media: `${V}/visuals/mediator_plaza.jpg`,
    Leadership: `${V}/visuals/leader_throne.jpg`,
    SupplyChain: `${V}/visuals/supply_depot.jpg`,
    Transport: `${V}/visuals/transport_hub.jpg`,
    Surveillance: `${V}/visuals/security_room.jpg`,
    Research: `${V}/visuals/science_lab.jpg`,
    Authentication: `${V}/visuals/data_stream_overlay.mp4`,
  },

  // --- OUTCOMES ---
  OUTCOMES: {
    Prison: `${A}/outcomes/south-facing_view_age_1.png`,
    Summons: `${A}/outcomes/summons_to_carpet_age_1.png`,
    BlueWall: `${A}/outcomes/Blue_wall_of_silence_age_1.png`,
    Downshifting: `${A}/outcomes/going_downshifting_age_1.png`,
    Recognition: `${A}/outcomes/recognition_of_origins_for_comfort_zone_age_1.png`,
    IntegrityPen: `${A}/outcomes/came_with_a_pen_age_1.png`,
    RevoContactor: `${A}/outcomes/contractor_of_revolutions_on_demand_age_1.png`,
    Hospitalized: `${A}/outcomes/hospitalized_for_job_preservation_age_1.png`,
    Indispensable: `${A}/outcomes/indispensable_age_1.png`,
    CampaignJob: `${A}/outcomes/riot_campaign_for_your_job_age_1.png`,

    Precariat: `${A}/outcomes/Precariat_age_2.png`,
    WolfTicket: `${A}/outcomes/Wolfs_ticket_age_2.png`,
    Conspiracy: `${A}/outcomes/conspiracy_plot_age2.png`,
    ScrewSystem: `${A}/outcomes/Screw_of_the_system_age_2.png`,
    CandleEnds: `${A}/outcomes/to_burn_candle_at_both_ends_age_2.png`,
    CogInWheel: `${A}/outcomes/cog_in_the_wheel_age_2.png`,
    POPServices: `${A}/outcomes/cashmaking_completed_age_2.png`,
    Recommended: `${A}/outcomes/recommended_to_influential_age_2.png`,
    Stasher: `${A}/outcomes/drug_stash_mule_age_2.png`,
    Request: `${A}/outcomes/resolution_by_sex_age_2.png`,
    InWaiting: `${A}/outcomes/waiting_for_his_turn_age_2.png`,

    Puppet: `${A}/outcomes/Oligarchy-ruled_puppet_politician_age_3.png`,
    CancelCulture: `${A}/outcomes/Become_unknown_and_censored_to_cancel_culture_age_3.png`,
    Passionary: `${A}/outcomes/passionary_trail_with_obligation_to_alter_reality_age_3.png`,
    Troyan: `${A}/outcomes/Troyan_aid_and_charity_age_3.png`,
    Sacrifice: `${A}/outcomes/expected_to_sacrifice_yourself_to_save_them_age_3.png`,
    Descending: `${A}/outcomes/descending_progression_age_3.png`,
    Relocate: `${A}/outcomes/informer_warns_to_relocate_age_3.png`,
    DibShare: `${A}/outcomes/sharing_the_dibs_age_3.png`,
    Snitch: `${A}/outcomes/snitching_about_you_age_3.png`,
    Placeholder: `${A}/outcomes/placeholder_backed_by_elite_age_3.png`
  },

  // --- STILLS ---
  STILLS: {
    Voters: `${A}/stills/voters%20NPC%20for%20the%20Age%203-Recalibration.png`,
    Judges: `${A}/stills/Judges%20NPC%20Level%203Recalibration.png`,
    Competitors: `${A}/stills/Competitors%20NPC%20Age3Recalibration.png`,
    Employees: `${A}/stills/Employeees%20of%20the%20industry%20NPC%20for%20Age%203%20Recalibration.png`, 
    Newcomers: `${A}/stills/Newcomers%20NPC%20Age%203%20Ascent.png`,
    StartScreen: `${A}/stills/start%20game%20.jpeg`
  },

  // --- TOOLS ---
  TOOLS: {
    Admin: `${A}/tools/admin_resource_tool.png`,
    Charter: `${A}/tools/ancestral_charter.png`,
    HairyHand: `${A}/tools/hairy_hand_of%20promotion.png`,
    Pass: `${A}/tools/trough_pass.png`,
    Codex: `${A}/tools/whisperer%27s%20codex.png`
  },
  
  // --- BADGES ---
  BADGES: {
      Integrity: `${A}/badges/%20integrity_badge.png`, 
      Master: `${A}/badges/master_badge.png`,
      Initiate: `${A}/badges/initiate_badge.png`,
  }
};

export const getAvatar = (profession, gender) => {
  const p = profession.toLowerCase();
  const g = gender.toLowerCase();
  
  if (profession === 'Legal' && gender === 'Female') return `${A}/player_avatars/leqgal_pro_female.png`;
  if (profession === 'Hospitality' && gender === 'Male') return `${A}/player_avatars/hotel&hospitality_pro_male.png`;
  if (profession === 'Hospitality' && gender === 'Female') return `${A}/player_avatars/hotel&hospitality_female.png`;
  if (profession === 'Aestheticians') return `${A}/player_avatars/aesthetician_${g}.png`;
  
  const map = {
    'logistics': 'logistic_coordinator',
    'medical': 'medical_pro',
    'banking': 'banking_pro',
    'mining': 'mining_engineer',
    'oil & gas': 'oil&gas_pro',
    'pilot & atc': 'pilot&atc',
    'cabin crew': 'cabin_crew_pro',
    'young genius': 'young_genius',
    'dream achiever': 'dream_achiever'
  };
  
  return `${A}/player_avatars/${map[p] || p}_${g}.png`;
};